<template>
	<div id="patientPanel" class="d-flex flex-column align-items-stretch">
		<div class="header shadow-sm">
			<div class="d-flex layout-row align-items-center">
				<button class="d-inline-block app-menu d-sm-none" v-on:click="toggleMenu">
					<i class="material-icons">menu</i>
				</button>
				<!-- <img src="@/assets/images/logo-image2doc-wire-white.png" alt="image2doc"> -->
				<img v-bind:src="this.$user.patient.logo" alt="clinica">
			</div>
		</div>

		<div class="d-flex flex-row flex-grow-1">
			<div id="leftMenu" v-bind:class="{ active: isActive }" class="shadow-sm d-flex flex-column align-items-stretch" v-on:click="toggleMenu">
				<div class="mt-5 flex-grow-1 d-flex flex-column align-items-stretch">
					<router-link class="d-flex item-menu align-items-center flex-row" :to="{name: 'patientExams'}">
						<i class="material-icons">view_stream</i> <div class="p-2">{{ $t('MyExams') }}</div>
					</router-link>
					<router-link class="d-flex item-menu align-items-center flex-row" :to="{name: 'patientAccount'}">
						<i class="material-icons">account_box</i> <div class="p-2">{{ $t('MyProfile') }}</div>
					</router-link>
					<router-link class="d-flex item-menu align-items-center flex-row" :to="{name: 'patientClinicContact'}">
						<i class="material-icons">phone</i> <div class="p-2">{{ $t('Contact') }}</div>
					</router-link>
					<a class="d-flex item-menu align-items-center flex-row b-logout" v-on:click="logout()">
						<i class="material-icons">exit_to_app</i> <div class="p-2">{{ $t('Exit') }}</div>
					</a>
					<div class="flex-grow-1"></div>
					<router-link :to="{name: 'patientAccount'}" class="p-user">
						<div class="d-flex align-items-center">
							<div class="avatar m-2">
								<img v-bind:src="this.$user.patient.picture" class="rounded-circle" height="32">
							</div>
							<div class="infos m-2">
								{{this.$user.patient.name}}
							</div>
						</div>
					</router-link>
				</div>
			</div>
			<div id="patientContentView" v-on:click="(isActive ? toggleMenu() : null)" class="d-flex flex-grow-1">
				<div class="alert alert-warning"
						v-if="!this.$user.patient.email || !this.$user.patient.birthdate | !this.$user.patient.rg || !this.$user.patient.phone || !this.$user.patient.cpf"
				>
					<span v-html="$t('HelloYourProfileIsIncomplete{PersonName}', {PersonName: this.$user.patient.name.split(' ')[0]})"></span>
					<router-link :to="{name: 'patientAccount'}">{{ $t('ClickHere') }}</router-link>
					<span>{{ $t('toUpdateIt') }}</span>
				</div>
				<router-view/>
			</div>

		</div>
	</div>
</template>

<script>
import tinycolor from 'tinycolor2'
import {Auth} from '@/services'

export default {
	name: "patientPanelPage",
	data() {
		return {
			isActive: false,
			app: {
				topnavColor: null,
				buttonColor: null,
			}
		}
	},
	methods: {
		toggleMenu(_status) {
			//this.isActive = _status || !this.isActive;
			this.isActive = !this.isActive;
			console.info("[Event] Menu toggle")
		},
		logout() { 
			Auth.logout()
			this.$router.push({name: 'loginForm'})
		}
	},
	mounted() {
		Auth.setColorPallete().getPalette().then(pallete => {
			console.log(pallete);

			let colors = {
				primary: pallete.Vibrant.getHex(),
				secondary: pallete.LightVibrant ? pallete.LightVibrant.getHex() : pallete.LightMuted ? pallete.LightMuted.getHex() : pallete.Muted.getHex(),
				muted: pallete.DarkVibrant ? pallete.DarkVibrant.getHex() : pallete.DarkMuted.getHex()
			}

			let css = `
				.header {
					background-color: ${tinycolor(colors.primary).isLight ? '#fff' : colors.primary} !important;
					z-index:100;
				}

				#leftMenu .item-menu.router-link-exact-active {
					color: ${colors.primary} !important;
					border-color: ${colors.primary} !important;
				}

				#leftMenu .p-user {
					background-color: ${colors.secondary} !important;
					border-color: ${colors.primary} !important;
					color: ${tinycolor(colors.muted).isLight ? '#333' : '#fff'} !important;
				}

				.btn-secondary {
					background-color: ${colors.muted} !important;
				}
				
				.Loader .Bar {
					background: ${pallete.Vibrant.getHex()} !important;
				}

				.app-menu .material-icons {
					color:${colors.primary};
				}
			`

			var head = document.getElementsByTagName('head')[0];
			var s = document.createElement('style');
			s.setAttribute('type', 'text/css');
			
			if (s.styleSheet) {   // IE
					s.styleSheet.cssText = css;
			} else {                // the world
					s.appendChild(document.createTextNode(css));
			}
			
			head.appendChild(s);
		})
	}
}

</script>

<style lang="scss">
@import '../../assets/_vars';

#patientPanel {
	width:100%;
	height:100%;

	* {
		transition: 110ms all cubic-bezier(0.075, 0.82, 0.165, 1);
	}

	.header {
			height:64px;
			padding:8px;
			background:#fff;
			z-index:100;

			img {
				display:inline-block;
				height:48px;
				margin:0 16px 0 16px;
			}

			button {
				background:none;
				color:#fff;
				border:0;
				width:48px;
				font-size:32px;
			}
		}

	#leftMenu {
		background:#fff;
		z-index:50;

		@media screen and (max-width: $mobile) {
			position:fixed;
			width:80%;
			top:0;
			height:100%;
			left:-100%;
			transition: 250ms all cubic-bezier(0.075, 0.82, 0.165, 1);

			&.active {
				left:0;
			}
		}

		a {
			//display: block;
			font-size: 16px;
			padding: 16px;
			border-left: 3px solid transparent;
			text-decoration: none;
			color:$deepGrey;
			font-weight: 500;
			cursor:pointer;

			&.b-logout {
				color:#D32F2F;
				border-color:#D32F2F;
			}

			&.p-user {
				background:$deepBlue;
				color:#fff;

				.avatar {
					width:32px;
					height:32px;
					overflow: hidden;
					position: relative;;
					background:#fff;
					border-radius:16px;

					img {
						position:absolute;
						top:0;
						left:0;
						right:0;
						bottom:0;
						margin:auto;
						background:#fff;
					}
				}

				&.router-link-exact-active {
					color:#fff;
				}
			}

			&:hover {
				border-left-color: $grey;
			}

			&.router-link-exact-active   {
				border-left-color: $lightBlue;
				color: $lightBlue;
			}
		}
	}

	#patientContentView {
		background:#f1f1f1;
		display:flex;
		flex-direction: column;
		overflow: auto;
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/patient/patientPanelPage.vue